export default {
    state: () => ({
        data: {
            isOpenSmallBasket: false,
        }
    }),
    mutations: {
        ['basket/setState'](state, payload) {
            state.data = { ...payload, isOpenSmallBasket: state.data.isOpenSmallBasket};
        },
        ['basket/changeOpenSmallBasket'](state, payload) {
            state.data = { ...state.data, isOpenSmallBasket: payload };
        },
    },
    actions: {
        async ['basket/add']({ state: { data }, commit, getters }, { id, count = 1}) {
            try {
                const { path, 'params-example-data': params } = data.routes.add;
                const requestParams = {
                    action: params.action,
                    id,
                };

                const { status, data: responseData } = await axios.post(path, requestParams);
                if (status !== 200) {
                    throw `add to basket bad response status ${status}`
                }

                commit('basket/setState', responseData);
                return responseData;
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/remove']({ state: { data }, commit, dispatch, rootState }, payload) {
            try {
                const { path, ['params-example-data']: params } = data.routes.remove;
                const requestParams = {
                    action: params.action,
                    ...payload,
                }
                const { status, data: responseData } = await axios.post(path, requestParams);

                if (status !== 200 || responseData.error) {
                    throw `Bad request delete product from basket status: ${ status } \n ${ responseData.error }`;
                }
                if (!responseData.items) commit('basket/changeOpenSmallBasket', false);

                /**
                 * https://jira.aniart.com.ua/browse/SOVA2-286
                 * Редирект на главную после очищения корзины от всех товаров в чекауте
                 */
                if (!responseData.items && responseData.redirect) window.location.href = responseData.redirect;

                commit('basket/setState', responseData);
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/update']({ state: { data }, commit, dispatch, rootState }, { id, count = 1}) {
            try {
                const { path, 'params-example-data': params } = data.routes.update;
                const requestParams = {
                    action: params.action,
                    id,
                    count,
                };

                const { status, data: responseData } = await axios.post(path, requestParams);
                if (status !== 200) {
                    throw `add to basket bad response status ${status}`
                }

                commit('basket/setState', responseData);
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/createOrderByOneClick']({ state: { data }, dispatch }, requestParams) {
            try {
                const { path, 'params-example-data': params } = data?.routes?.buyOneClick;

                const ajaxParams = {
                    ...requestParams,
                    action: params.action,
                    LANGUAGE_ID : params.LANGUAGE_ID
                };

                const { status, data: responseData } = await axios.post(path, ajaxParams);
                if (status !== 200) {
                    throw `create order one click bad response status ${status}`
                }
                await dispatch('basket/updateBasketData');

                return responseData;
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/updateBasketData']({ state, commit }) {
            try {
                const { path, ['params-example-data']: { LANGUAGE_ID, action } } = state.data.routes?.updateSmallBasket;
                // console.log();
                const { status, data } = await axios.post(path, { action, LANGUAGE_ID });

                if (status === 200) {
                    commit('basket/setState', data);
                }
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/setCoupon']({ state, commit }, payload) {
            commit('global/loaderStart');
            const { path, 'params-example-data': { action } } = state.data.routes?.setCoupon;
            const props = {
                coupon: payload,
                action,
            }

            const { data } = await axios.post(path, props);
            commit('basket/setState', data);

            commit('global/loaderStop');
            return data;
        },
        async ['basket/deleteCoupon']({ state, commit }, payload) {
            commit('global/loaderStart');
            const { path, 'params-example-data': { action } } = state.data.routes?.delCoupon;
            const props = {
                coupon: payload,
                action,
            }

            const { data } = await axios.post(path, props);
            commit('basket/setState', data);
            commit('global/loaderStop');
            return data;
        },
        async ['basket/setCertificate']({ state, commit }, payload) {
            try {
                commit('global/loaderStart');
                const { path, 'params-example-data': { action } } = state.data.routes?.setCertificate;
                const props = {
                    certificate: payload,
                    action,
                }

                const { data, status } = await axios.post(path, props);

                if (status !== 200) {
                    throw `Something went wrong status ${ status }`;
                } else if (!data.error) {
                    commit('basket/setState', data);
                }

                return data;
            } catch (err) {
                console.error(err);
            } finally {
                commit('global/loaderStop');
            }
        },
        async ['basket/deleteCertificate']({ state, commit }, payload) {
            try {
                commit('global/loaderStart');

                const { path, 'params-example-data': { action } } = state.data.routes?.delCertificate;
                const props = {
                    certificate: payload,
                    action,
                }

                const { data, status } = await axios.post(path, props);

                if (status !== 200) {
                    throw `Something went wrong status ${ status }`;
                }

                commit('basket/setState', data);

            } catch (err) {
                console.error(err);
            } finally {
                commit('global/loaderStop');
            }
        },
        // async ['basket/changeSKU']({ state, commit }, payload) {
        //     try {
        //         commit('global/loaderStart');
        //         const { path, ['params-example-data']: { action } } = state.data.routes.changeSku;
        //         const { status, data: { product } } = await axios.get(payload.size.detailPage, { params: { api: 'y' } });
        //
        //         if (status !== 200) throw new Error(`bad request response: ${ status }`);
        //
        //         const newId = product?.offer?.id ?? product.id;
        //
        //         if (newId === payload.id) {
        //             return;
        //         }
        //
        //         const response = await axios.post(path, {
        //             action,
        //             newId,
        //             oldId: payload.id,
        //         });
        //
        //         if (response.status === 200) {
        //             commit('basket/setState', response.data);
        //         }
        //
        //         commit('global/loaderStop');
        //         return product;
        //     } catch (err) {
        //         console.error(err);
        //     }
        // },
        /** remove IPost order **/
        async ['basket/getBackBasketItems']({ state, commit }) {
            const IPostFieldsString = window.sessionStorage.getItem('IPostFields');
            if (IPostFieldsString && location.pathname !== '/personal/order/make/') {
                await axios.post('/ajax/', {
                    action: 'getBackBasketItems',
                });
                window.sessionStorage.removeItem('IPostFields');
            }
        }
    },
    getters: {
        // ['basket/inBasket']: ({ data: { items } }) => id => {
        //     try {
        //         if (Array.isArray(items)) {
        //             return !!items.find(el => el?.offer?.id == id ?? el?.id == id);
        //         } else {
        //             return false;
        //         }
        //     } catch (err) {
        //         console.error(err);
        //         return false;
        //     }
        // },
        // ['basket/getProductById']: ({ data: { items } }) => id => {
        //     try {
        //         if (Array.isArray(items)) {
        //             return items.find(el => el.id == id);
        //         } else {
        //             return false;
        //         }
        //     } catch (err) {
        //         console.error(err);
        //         return false;
        //     }
        // },
        ['basket/getBasketCoupon']: ({ data: { price } }) => {
            try {
                if (price?.coupons) {
                    return {
                        name: Object.keys(price.coupons)[0],
                        value: Object.values(price.coupons)[0],
                    }
                }
                return null;
            } catch (err) {
                console.error(err);
                return false;
            }
        },
        ['basket/getSovaClub']: ({ data: { price } }) => {
            try {
                if (price?.clubCard) {
                    return {
                        name: Object.keys(price.clubCard)[0],
                        value: Object.values(price.clubCard)[0],
                    }
                }
                return null;
            } catch (err) {
                console.error(err);
                return false;
            }
        },
    }
}